import { __ } from "@wordpress/i18n";


import {
  useBlockProps,
  MediaPlaceholder,
  InspectorControls,
  BlockControls,
  MediaReplaceFlow,
} from "@wordpress/block-editor";
import {
  PanelBody,
  RangeControl,
  SelectControl,
  ToggleControl,
} from "@wordpress/components";
import { useEffect } from "@wordpress/element";
import "./editor.scss";

export default function Edit({ attributes, setAttributes, clientId }) {
  const {
    images,
    column,
    imageSize,
    masonry,
    linkTo,
    imageHeight,
    imageGap,
    enablePopup,
  } = attributes;

  const options = [
    { label: "Large", value: "large" },
    { label: "Thumbnail", value: "thumbnail" },
    { label: "Medium", value: "medium" },
    { label: "Fullsize", value: "fullsize" },
  ];
  const linkOptions = [
    { label: "MediaFile", value: "mediaFile" },
    { label: "Attachment", value: "attachment" },
  ];

  const ALLOWED_MEDIA_TYPES = ["image"];
  const hasImages = images && images.length > 0;

  const onSelectImages = (selectedImages) => {
    const imageList = selectedImages.map((image) => ({
      id: image.id,
      caption: image.caption,
      url: image.url,
    }));
    setAttributes({ images: imageList });
  };

  const onSelectMedia = (newImages) => {
    console.log(newImages  )
    const imageList = newImages.map((image) => ({
     
      id: image.id,
      caption: image.caption,
      url: image.url,
    }));
    setAttributes({ images: imageList });
    console.log( imageList )
  };

  return (
    <div {...useBlockProps()}>
      <InspectorControls>
        <PanelBody title={__("Gallery Settings", "templazee")}>
          <RangeControl
            label={__("No. of Columns", "templazee")}
            value={column}
            onChange={(newColumn) => setAttributes({ column: newColumn })}
            min={1}
            max={3}
          />
          {/* <SelectControl
            label={__("Select Image Size")}
            value={imageSize}
            options={options}
            onChange={(newOption) => setAttributes({ imageSize: newOption })}
          /> */}

          <ToggleControl
            label={__("Enable Masonry Layout","templazee")}
            checked={masonry}
            onChange={(isMasonry) => setAttributes({ masonry: isMasonry })}
          />
          {!masonry && (
            <RangeControl
              label={__("Image Height", "templazee")}
              value={imageHeight}
              onChange={(newHeight) =>
                setAttributes({ imageHeight: newHeight })
              }
              min={50}
              max={500}
            />
          )}
   
        </PanelBody>
      </InspectorControls>
      <BlockControls>
        <MediaReplaceFlow
          allowedTypes={ALLOWED_MEDIA_TYPES}
          accept="image/*"
          onSelect={onSelectMedia}
          name={__("Replace Images","templazee")}
          multiple={true}
          mediaIds={images.map((image) => image.id)}
          addToGallery={hasImages}
        />
      </BlockControls>
      {hasImages ? (
        masonry ? (
          <div
            className="masonry-grid"
            style={{
              columnCount: column,
              columnGap: `${imageGap}px`,
              WebkitColumnCount: column,
              MozColumnCount: column,
            }}
          >
              {images.map((image) => (
                <div
                  key={image.id}
                  className={`masonry-item size-${imageSize}`}
                  style={{
                    breakInside: "avoid",
                    marginBottom: `${imageGap}px`,
                  }}
                >
                  <img
                    src={image.url}
                    alt={image.caption}
                    className={`wp-image-${image.id}`}
                    style={{
                      width: "100%",
                      height: masonry ? "auto" : `${imageHeight}px`,
                      objectFit: masonry ? "initial" : "cover",
                      margin: 0, 
                      display: "block",
                    }}
                  />
                </div>
              ))}
          </div>
        ) : (
          <div
            className={`grid-layout ${imageSize || ""}`}
            style={{
              display: "grid",
              gridTemplateColumns: `repeat(${column}, 1fr)`,
              gap: `${imageGap}px`,
            }}
          >
            {images.map((image) => (
              <div key={image.id} className="gallery-item">
                <a>
                  <img
                    src={image.url}
                    alt={image.caption}
                    style={{
                      width: "100%",
                      height: `${imageHeight}px`,
                      objectFit: "cover",
                      margin: 0,
                      display: "block",
                    }}
                  />
                </a>
              </div>
            ))}
          </div>
        )
      ) : (
        <MediaPlaceholder
          onSelect={onSelectImages}
          allowedTypes={ALLOWED_MEDIA_TYPES}
          multiple
          gallery
          labels={{
            title: __("Add Gallery Images", "templazee"),
          }}
        />
      )}
    </div>
  );
}